export const CHARTIQ_FETCH_DATA = 'chartiq/FETCH_DATA';
export const CHARTIQ_CHANGE_CHART_DATA = 'chartiq/CHANGE_CHART_DATA';
export const CHARTIQ_SET_CHART_TYPE = 'chartiq/SET_CHART_TYPE';
export const CHARTIQ_SET_CHART_TYPE_AND_SAVE = 'chartiq/SET_CHART_TYPE_AND_SAVE';
export const CHARTIQ_IMPORT_LAYOUT = 'chartiq/IMPORT_LAYOUT';
export const CHARTIQ_IMPORT_DRAWINGS = 'chartiq/IMPORT_DRAWINGS';
export const CHARTIQ_SET_SYMBOL = 'chartiq/SET_SYMBOL';
export const CHARTIQ_SET_SYMBOL_AND_SAVE = 'chartiq/SET_SYMBOL_AND_SAVE';
export const CHARTIQ_ADD_COMPARISON = 'chartiq/ADD_COMPARISON';
export const CHARTIQ_ADD_COMPARISON_AND_SAVE = 'chartiq/ADD_COMPARISON_AND_SAVE';
export const CHARTIQ_REMOVE_COMPARISON = 'chartiq/REMOVE_COMPARISON';
export const CHARTIQ_REMOVE_COMPARISON_AND_SAVE = 'chartiq/REMOVE_COMPARISON_AND_SAVE';
export const CHARTIQ_SHARE_CHART = 'chartiq/SHARE_CHART';
export const CHARTIQ_SET_SHARE_STATUS = 'chartiq/SET_SHARE_STATUS';
export const CHARTIQ_CHANGE_VECTOR_PARAMS = 'chartiq/CHANGE_VECTOR_PARAMS';
export const CHARTIQ_CHANGE_VECTOR_STYLE = 'chartiq/CHANGE_VECTOR_STYLE';
export const CHARTIQ_CHANGE_VECTOR_LINE_PARAMS = 'chartiq/CHANGE_VECTOR_LINE_PARAMS';
export const CHARTIQ_TOGGLE_AXIS_LABELS = 'chartiq/TOGGLE_AXIS_LABELS';
export const CHARTIQ_SET_PERIODICITY = 'chartiq/SET_PERIODICITY';
export const CHARTIQ_SET_PERIODICITY_WITH_LOADER = 'chartiq/SET_PERIODICITY_WITH_LOADER';
export const CHARTIQ_SET_SPAN_WITH_LOADER = 'chartiq/SET_SPAN_WITH_LOADER';
export const CHARTIQ_SET_RESPONSIVE_SIZE = 'chartiq/SET_RESPONSIVE_SIZE';
export const CHARTIQ_TOGGLE_CROSSHAIRS = 'chartiq/TOGGLE_CROSSHAIRS';
export const CHARTIQ_TOGGLE_CROSSHAIRS_AND_SAVE = 'chartiq/TOGGLE_CROSSHAIRS_AND_SAVE';
export const CHARTIQ_TOGGLE_TIMEZONE_MODAL = 'chartiq/TOGGLE_TIMEZONE_MODAL';
export const CHARTIQ_DRAW = 'chartiq/DRAW';
export const CHARTIQ_DRAWINGS_CHANGED = 'chartiq/DRAWINGS_CHANGED';
export const CHARTIQ_LAYOUT_CHANGED = 'chartiq/LAYOUT_CHANGED';
export const CHARTIQ_LAYOUT_CHANGED_AND_SAVE = 'chartiq/LAYOUT_CHANGED_AND_SAVE';
export const CHARTIQ_CREATE_UNDO_STAMP = 'chartiq/CREATE_UNDO_STAMP';
export const CHARTIQ_UPDATE_UNDO_STAMPS = 'chartiq/UPDATE_UNDO_STAMPS';
export const CHARTIQ_UNDO = 'chartiq/UNDO';
export const CHARTIQ_REDO = 'chartiq/REDO';
export const CHARTIQ_CLEAR = 'chartiq/CLEAR';
export const CHARTIQ_SAVE_LAYOUT = 'chartiq/SAVE_LAYOUT';

export const CHARTIQ_CHANGE_DRAWINGS = 'chartiq/CHANGE_DRAWINGS';
export const CHARTIQ_REDID = 'chartiq/REDID';
export const CHARTIQ_SET_CHART_CONTAINER = 'chartiq/SET_CHART_CONTAINER';
export const CHARTIQ_SET_CONTAINER = 'chartiq/SET_CONTAINER';
export const CHARTIQ_SET_TIME_ZONE = 'chartiq/SET_TIME_ZONE';
export const CHARTIQ_UNDID = 'chartiq/UNDID';
export const CHARTIQ_UNDO_STAMPS = 'chartiq/UNDO_STAMPS';

export const CHARTIQ_SUBSCRIBE_CALLBACK = 'chartiq/SUBSCRIBE_CALLBACK';
